<template>
    <div class="my-4" >
        <b-alert show variant="light">
            <p class="text-dark">
                Para ver las respuestas haga click en el nombre del estudiante deseado.
                Solo se pueden ver las respuestas de estudiantes que hayan completado la encuesta/quiz.
                Para completar automáticamente todas las encuestas/quices puede cerrarla.<br/><br/>
                Si desea reiniciar las respuestas de un estudiante en particular, puede otorgarle un nuevo intento
                haciendo click en el botón amarillo en la fila del estudiante deseado.
            </p>
        </b-alert>
        <b-tabs active-nav-item-class="bg-primary text-white">
            <b-tab
                v-for="(studentRows, courseSection) in answerSections"
                :key="`answer-section-${courseSection}`"
                :title="courseSection"
            >
                <b-table
                    :ref="`participantsTable_${courseSection}`"
                    responsive
                    :items="studentRows"
                    :fields="studentSurveyAnswerFields"
                    :sort-by="'fullname'"
                    :sort-desc="false"
                >
                    <template
                        v-if="isUserStudenTeacherOrBetter"
                        v-slot:cell(fullname)="data"
                    >
                        <router-link
                            v-if="data.item.completed === 'Si'"
                            :to="{ name: 'site-teacher-surveys-answers', params: { surveyId: survey.id, studentSurveyId: data.item.studentSurveyId } }"
                        >
                            {{ data.value }}
                        </router-link>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template v-slot:cell(totalValueDisplay)="data">
                        <span v-if="data.item.completed === 'Si'">{{ data.value }}</span>
                        <span v-else>-</span>
                    </template>
                    <template
                        v-if="isUserStudenTeacherOrBetter"
                        v-slot:cell(actions)="data"
                    >
                        <span>
                            <b-button
                                size="sm"
                                variant="warning"
                                @click="onResetAnswers(data.item.studentSurveyId)"
                                title="Reiniciar respuestas / Nuevo intento"
                                :disabled="data.item.completed === 'No'"
                            >
                                <b-icon-arrow-repeat />
                            </b-button>
                        </span>
                    </template>
                </b-table>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'SurveyAnswers',
    computed: {
        ...mapState({
            activeSite: 'activeSite',
            survey: 'selectedSurveyObject'
        }),
        ...mapGetters([
            'isUserStudenTeacherOrBetter'
        ]),
        answerSections () {
            let formattedSections = {}
            for (const section in this.survey.sections) {
                let participantsInSection = this.survey.sections[section].filter((student) => student.studentSurvey !== null)
                if (participantsInSection.length) {
                    formattedSections[section] = participantsInSection.map((student) => {
                        return {
                            identityCard: student.identityCard,
                            fullname: `${student.lastname}, ${student.name}`,
                            studentSiteId: student.studentSiteId,
                            studentSurveyId: student.studentSurvey.id,
                            totalValueDisplay: student.studentSurvey.totalValue.toFixed(2) + ' %',
                            completed: student.studentSurvey.completedAt !== null ? 'Si' : 'No',
                            attempt: student.studentSurvey.attempts
                        }
                    })
                }
            }
            return formattedSections
        },
        studentSurveyAnswerFields () {
            let fields = [
                { key: 'identityCard', label: '# Cédula', sortable: true },
                { key: 'fullname', label: 'Nombre', sortable: true },
                { key: 'completed', label: 'Completo', class: 'text-center' },
                { key: 'attempt', label: 'Intento', class: 'text-center' }
            ]
            if (this.survey.isEvaluated) {
                fields.push({ key: 'totalValueDisplay', label: 'Resultado', class: 'text-center' })
            }
            if (this.isUserStudenTeacherOrBetter) {
                fields.push({ key: 'actions', label: 'Acciones', class: 'text-center' })
            }
            return fields
        }
    },
    methods: {
        ...mapActions([
            'restartStudentSurvey',
            'readSingleSiteTeacherSurvey'
        ]),
        async onResetAnswers (studentSurveyId) {
            let modalBodyText = this.$createElement('p', [
                '¿Esta seguro que desea reiniciar la encuesta/quiz para el participante?',
                this.$createElement('br'),
                this.$createElement('br'),
                'Esto reiniciará todas sus respuestas y resultado obtenido en caso de ser un quiz.'
            ])
            try {
                let value = await this.$bvModal.msgBoxConfirm([modalBodyText], {
                    title: '¡Atención!',
                    okVariant: 'warning',
                    okTitle: 'Reiniciar',
                    cancelTitle: 'Cancelar',
                    centered: true
                })
                if (value) {
                    // Restart the survey/quiz after confirmation
                    var loader = this.$loading.show()
                    try {
                        const payloadData = { courseSiteId: this.activeSite.id, studentSurveyId: studentSurveyId }
                        await this.restartStudentSurvey(payloadData)
                        const reloadPayload = { courseSiteId: this.activeSite.id, surveyId: this.survey.id }
                        await this.readSingleSiteTeacherSurvey(reloadPayload)
                        this.$root.successToast(`La encuesta/quiz se ha reiniciado.`)
                    } catch (error) {
                        console.log({ error: error })
                        this.$root.dangerToast('No se pudo reiniciar la encuesta/quiz, intente más tarde.')
                    } finally {
                        loader.hide()
                    }
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        }
    }
}
</script>
